import React, { useState } from "react";
import { reisorTransportVisualKind } from "./reisorTransportVisualCore.js";
import { resolveReisorPublicAssetUrl } from "../../utils/reisorAssetUrl.js";

function Wheels({ compact = false }) {
  return (
    <>
      <circle cx={compact ? 35 : 30} cy="69" r="7" fill="currentColor" opacity="0.92" />
      <circle cx={compact ? 75 : 84} cy="69" r="7" fill="currentColor" opacity="0.92" />
    </>
  );
}

function VehicleGlyph({ kind }) {
  if (kind === "TRACTOR") {
    return (
      <svg viewBox="0 0 120 88" className="h-full w-full" aria-hidden="true">
        <path d="M25 49h20l8-22h23l9 22h14v16H25z" fill="currentColor" opacity="0.18" />
        <path d="M50 27h26l9 22H42z" fill="none" stroke="currentColor" strokeWidth="5" strokeLinejoin="round" />
        <path d="M24 49h75v16H24z" fill="none" stroke="currentColor" strokeWidth="5" strokeLinejoin="round" />
        <circle cx="38" cy="69" r="12" fill="none" stroke="currentColor" strokeWidth="5" />
        <circle cx="89" cy="69" r="9" fill="none" stroke="currentColor" strokeWidth="5" />
        <path d="M63 27V15M82 22h11" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
      </svg>
    );
  }

  if (kind === "VAN" || kind === "BUS" || kind === "CAR") {
    return (
      <svg viewBox="0 0 120 88" className="h-full w-full" aria-hidden="true">
        <path d="M17 34c0-7 5-12 12-12h48c7 0 13 4 17 10l11 18v16H17z" fill="currentColor" opacity="0.16" />
        <path d="M17 34c0-7 5-12 12-12h48c7 0 13 4 17 10l11 18v16H17z" fill="none" stroke="currentColor" strokeWidth="5" strokeLinejoin="round" />
        <path d="M73 26v24h27M38 26v24" stroke="currentColor" strokeWidth="4" opacity="0.75" />
        <Wheels compact />
      </svg>
    );
  }

  if (kind === "SPECIAL" || kind === "TOW") {
    return (
      <svg viewBox="0 0 120 88" className="h-full w-full" aria-hidden="true">
        <path d="M23 55h66v13H23z" fill="currentColor" opacity="0.18" />
        <path d="M24 55h65v13H24z" fill="none" stroke="currentColor" strokeWidth="5" strokeLinejoin="round" />
        <path d="M43 55l17-26h14l13 26M60 29l27-13" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="37" cy="70" r="8" fill="none" stroke="currentColor" strokeWidth="5" />
        <circle cx="79" cy="70" r="8" fill="none" stroke="currentColor" strokeWidth="5" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 120 88" className="h-full w-full" aria-hidden="true">
      <path d="M15 27h61v35H15zM76 39h16l13 14v9H76z" fill="currentColor" opacity="0.16" />
      <path d="M15 27h61v35H15zM76 39h16l13 14v9H76z" fill="none" stroke="currentColor" strokeWidth="5" strokeLinejoin="round" />
      {kind === "REEFER" ? (
        <path d="M39 38v14M32 45h14M34 40l10 10M44 40L34 50" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" />
      ) : null}
      <Wheels />
    </svg>
  );
}

export default function ReisorTransportVisual({ item, className = "" }) {
  const kind = reisorTransportVisualKind(item);
  const rawPhotoUrl = String(item?.vehicle?.publicPhotoUrl || item?.vehicle?.photoUrl || "").trim();
  const photoUrl = resolveReisorPublicAssetUrl(rawPhotoUrl);
  const [failedPhotoUrl, setFailedPhotoUrl] = useState("");

  if (photoUrl && failedPhotoUrl !== photoUrl) {
    return (
      <div className={`overflow-hidden rounded-2xl bg-slate-100 ${className}`} data-reisor-transport-visual="photo">
        <img
          src={photoUrl}
          alt=""
          className="h-full w-full object-cover"
          loading="lazy"
          onError={() => setFailedPhotoUrl(photoUrl)}
        />
      </div>
    );
  }

  return (
    <div
      className={`flex items-center justify-center overflow-hidden rounded-2xl border border-blue-100 bg-gradient-to-br from-blue-50 via-white to-slate-100 p-2 text-blue-700 dark:border-slate-700 dark:from-slate-800 dark:via-slate-900 dark:to-slate-950 dark:text-blue-300 ${className}`}
      data-reisor-transport-visual={kind.toLowerCase()}
    >
      <VehicleGlyph kind={kind} />
    </div>
  );
}
